export const TextEditorClearStyles = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M1.5 4.04453L6.08667 8.6223L3.92667 13.3334H6.14889L7.60667 10.1512L11.6867 14.2223L12.8156 13.0934L2.63778 2.90675L1.5 4.04453ZM4.65556 2.66675L6.43333 4.44453H7.99778L7.50889 5.52008L9.02889 7.04008L10.22 4.44453H13.7044V2.66675H4.65556Z'
      fill='#334155'
    />
  </svg>
);
